import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "classes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopCoverClasses = _resolveComponent("TopCoverClasses")!
  const _component_OpenRegistration = _resolveComponent("OpenRegistration")!
  const _component_IndividualClasses = _resolveComponent("IndividualClasses")!
  const _component_FreeClass = _resolveComponent("FreeClass")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_TopCoverClasses),
    _createVNode(_component_OpenRegistration),
    _createVNode(_component_IndividualClasses),
    _createVNode(_component_FreeClass)
  ]))
}